import React from "react";
import {COOKIE_KEY} from "../../../constants";
import {Cookies} from "react-cookie";
import {MyBreadcrumb} from "../../../components";
import {Col, FloatButton, Row} from "antd";
import {t} from "i18next";

const cookies = new Cookies()

export const ProfessionalOrientationTest = () => {

  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN)


  return (
    <>

      <MyBreadcrumb title={"Test"}/>
      <FloatButton.BackTop visibilityHeight={10}/>

      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>
              <iframe height="600" width="100%" src={`https://beta.citorleu.kz/proforient/test?jwt=${token}`}/>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}